<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      {{source ? '' : ''}}
      <li>
        <router-link :to="{path: '/content'}">Content</router-link>
      </li>
      <li>
        <router-link :to="{path: '/content/video'}">Video Gratis</router-link>
      </li>
      <li class="active">Tambah Video Gratis</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Video Gratis</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Tambah Video Gratis</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">URL Video *</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" placeholder="Masukkan URL Video dan tekan enter" v-on:keydown="hideForm()" required v-model="url">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label"></label>
                  <div class="col-md-8 col-xs-12">
                      <span v-if="changeUrl"></span>
                    <button v-if="changeUrl" type="button" class="btn btn-success pull-left mb-3" @click="checkURL()">Preview URL</button>
                    <youtube v-if="!changeUrl" :video-id="videoId" ref="youtube" @playing="playing"></youtube>
                    <!-- <button @click="playVideo">play</button> -->
                  </div>
                </div>
                <div v-if="!changeUrl">
                    <div class="form-group">
                        <label class="col-md-2 control-label">Source</label>
                        <div class="col-md-8 col-xs-12">
                            <select class="form-control" v-model="source">
                                <option value="youtube">Youtube</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Judul Video *</label>
                        <div class="col-md-8 col-xs-12">
                            <input type="text" class="form-control" :readonly="!$route.query.id" placeholder="Judul Video" v-model="judul">
                            <span v-if="!$route.query.id">
                                <input type="checkbox" name="alt-title" v-model="altTitle" value="Bike"> Judul Alternatif
                            </span>
                        </div>
                        <div class="offset-2 col-md-8 col-xs-12 pt-0" v-if="altTitle">
                            <input type="text" class="form-control" placeholder="Judul Alternatif" v-model="judulalt" :required="altTitle">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Jenjang *</label>
                        <div class="col-md-2 col-xs-2">
                            <select class="form-control" v-model="jenjang" @change="resetKelas()">
                                <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" v-if="jenjang">
                        <label class="col-md-2 control-label">Kelas *</label>
                        <div class="col-md-2 col-xs-2">
                          <div v-if="jenjang === 'SD'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="1" v-model="kelas"/> &nbsp;1
                            </span>
                            <span>
                              <input type="checkbox" value="2" v-model="kelas"/> &nbsp;2
                            </span>
                            <span>
                              <input type="checkbox" value="3" v-model="kelas"/> &nbsp;3
                            </span>
                            <span>
                              <input type="checkbox" value="4" v-model="kelas"/> &nbsp;4
                            </span>
                            <span>
                              <input type="checkbox" value="5" v-model="kelas"/> &nbsp;5
                            </span>
                            <span>
                              <input type="checkbox" value="6" v-model="kelas"/> &nbsp;6
                            </span>
                          </div>
                          <div v-if="jenjang === 'SMP'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="7" v-model="kelas"/> &nbsp;7
                            </span>
                            <span>
                              <input type="checkbox" value="8" v-model="kelas"/> &nbsp;8
                            </span>
                            <span>
                              <input type="checkbox" value="9" v-model="kelas"/> &nbsp;9
                            </span>
                          </div>
                          <div v-if="jenjang === 'SMA'">
                            <!-- <select class="form-control" v-model="kelas">
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select> -->
                            <span>
                              <input type="checkbox" value="10" v-model="kelas"/> &nbsp;10
                            </span>
                            <span>
                              <input type="checkbox" value="11" v-model="kelas"/>&nbsp; 11
                            </span>
                            <span>
                              <input type="checkbox" value="12" v-model="kelas"/> &nbsp;12
                            </span>
                          </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Mata Pelajaran *</label>
                        <div class="col-md-8 col-xs-12">
                             <select class="form-control" v-model="mapel_code">
                                <option v-for="item in mapelList" v-bind:key="item.id" :value="item.code">{{item.nama}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Status</label>
                      <div class="col-md-8 col-xs-12">
                        <select class="form-control" v-model="status">
                          <option value="PUBLISHED">Published</option>
                          <option value="HIDDEN">Hidden</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right" v-if="!changeUrl">
                <button v-if="!$route.query.id && !$route.query.liveId" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
                <button v-else type="button" class="btn btn-success pull-right" @click="saveData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ContentService from '@/services/content.js'
import videoService from '@/services/video.js'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'tryoutgroup-form',
  components: {
    'app-spinner': Spinner,
  },
  data: function() {
    return {
      modul: null,
      isLoading: false,
      showModal: false,
      errors: [],
      section_id: null,
      listSection: [],
      videoId: null,
      judulalt: null,
      changeUrl: true,
      altTitle: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: [],
      mapel_code: null,
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,
      status: 'HIDDEN'

    }
  },
  created(){
  },
  watch: {
    altTitle: function (val, oldval) {
      if (!val) {
        this.judulalt = this.judul
      }
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
    url: {
      get: function() {
        return this.$store.state.video.url
      },
      set: function(value) {
        this.$store.commit('video_set_url', value)
      }
    },
    judul: {
      get: function() {
        return this.$store.state.video.title
      },
      set: function(value) {
        this.$store.commit('video_set_title', value)
      }
    },
    kelas: {
      get: function() {
        return this.$store.state.video.grade
      },
      set: function(value) {
        this.$store.commit('video_set_grade', value)
      }
    },
    mapel: {
      get: function() {
        return this.$store.state.video.mapel
      },
      set: function(value) {
        this.$store.commit('video_set_mapel', value)
      }
    },
    interest: {
      get: function() {
        return this.$store.state.video.interest
      },
      set: function(value) {
        this.$store.commit('video_set_interest', value)
      }
    },
    description: {
      get: function() {
        return this.$store.state.video.description
      },
      set: function(value) {
        this.$store.commit('video_set_description', value)
      }
    },
    thumbnail: {
      get: function() {
        return this.$store.state.video.thumbnail
      },
      set: function(value) {
        this.$store.commit('video_set_thumbnail', value)
      }
    },
    source: {
      get: function() {
        return this.$store.state.video.source
      },
      set: function(value) {
        this.$store.commit('video_set_source', value)
      }
    },
    duration: {
      get: function() {
        return this.$store.state.video.duration
      },
      set: function(value) {
        this.$store.commit('video_set_duration', value)
      }
    }
  },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      console.log('\o/ we are watching!!!')
    },
    hideForm(){
      this.changeUrl = true
    },
    resetKelas() {
      this.kelas = []
      this.interest = 'ALL'
    },
    checkURL(){
      if(this.url){
        var context = this
        if(this.url.indexOf('embed') > -1){
          alert('video url tidak valid')
          return
        }else{
          this.videoId = this.url.substring(this.url.indexOf('=') + 1);
        }
        videoService.getVideoDetail(this.videoId,function (response) {
          if (response.success) {
            context.changeUrl = false
            context.judul = response.data.title
            context.judulalt = response.data.title
            context.source = response.data.source
            context.thumbnail = response.data.thumbnail
            context.description = response.data.description
            context.duration = response.data.duration_in_sec
          } else {
            return
          }
        })
      } else {
        alert('URL diperlukan')
      }
    },
    validateForm: function() {
      this.errors = []
      if (this.judul == '') this.errors.push('Judul wajib diisi')
      if (this.source == '') this.errors.push('Source wajib diisi')
      if (this.kelas.length < 1) this.errors.push('Kelas wajib diisi')
      if (this.judulalt == '') this.errors.push('Judul wajib diisi')
      if (this.jenjang == '' || this.jenjang == null) this.errors.push('Jenjang wajib diisi')
      if (this.status == '' || this.status == null) this.errors.push('Status wajib diisi')
      if (this.mapel_code == '' || this.mapel_code == null) this.errors.push('Mata Pelajaran wajib diisi')
      return this.errors.length == 0
    },
    saveData: function() {
      var context = this

      if(this.validateForm()) {
        context.isLoading = true
        var kel = this.kelas.map(function (x) {
          return parseInt(x, 10);
        });
        var strJSON = {
          youtube_url: this.url,
          // source: this.source,
          title: this.altTitle ? this.judulalt : this.judul,
          // jenjang: this.jenjang,
          grades: kel,
          description: this.description,
          duration: this.duration,
          thumbnail: this.thumbnail,
          mapel_code: this.mapel_code,
          status: this.status
        }


        if(!this.$route.query.id) {
            ContentService.createContentVideo(strJSON, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/video' })
              else alert('Gagal simpan data')
            })
        } else {
            ContentService.updateContentVideo(this.$route.query.id, strJSON, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/video' })
              else alert('Gagal ubah data')
            })
        }
      }
    },
    loadDataUpdate: function() {
      var context = this
      var data = this.$store.state.content.editContent
      var gradeWrap = []
      var jenjangWrap = ''
      if (data.grades.length > 0) {
        for (var i =0; i < data.grades.length; i++) {
          gradeWrap.push(''+data.grades[i].grade)
          jenjangWrap = data.grades[i].jenjang
        }
      }
      context.judul = data.title
      context.url = data.youtube_url
      context.jenjang = jenjangWrap
      context.kelas = gradeWrap
      context.source = 'youtube'
      context.duration = data.duration
      context.description = data.description
      context.mapel_code = data.mapel.code
      context.status = data.status
      var params = data.youtube_url.substring(data.youtube_url.indexOf('=') + 1)
      context.videoId = params.split('&')[0]
    }
  },
  mounted: function () {
    var context = this
    ContentService.getMapels(function(response) {
      if (response.success) {
        context.mapelList = response.data
      }
    })

    if(this.$route.query.id){
     this.changeUrl = false
     this.loadDataUpdate()
    } else {
      this.url = ''
    }

  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?726d6640